export default __webpack_public_path__ + "static/media/bhopal-banner-2-1024x682.9759e9ec.jpg";